import React from "react";
//import PropTypes from "prop-types";

export default function Giphy(props) {
    const {link} = props;
    return <img className={'message-gif'} src={link} alt={'gif'} />;
}

Giphy.defaultProps = {};
Giphy.propTypes = {};